import { render, staticRenderFns } from "./SpTwoModule2.vue?vue&type=template&id=ea5fc02a&scoped=true"
import script from "./SpTwoModule2.vue?vue&type=script&lang=js"
export * from "./SpTwoModule2.vue?vue&type=script&lang=js"
import style0 from "./SpTwoModule2.vue?vue&type=style&index=0&id=ea5fc02a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5fc02a",
  null
  
)

export default component.exports